module.exports = __webpack_public_path__ + "img/project-event.9d002945.png";